<template>
  <div class="cart" ref="container">
    <div class="title8">
      温馨提示：一次只能换单个商品，最多可以换{{ num }}件
    </div>
    <!-- <div class="flex top flex_around">
      <div class="item flex ali_center">
        <text class="iconfont icon-jinakangbaoicons17"></text>
        <text class="a">100%正品保证</text>
      </div>
      <div class="item flex ali_center">
        <text class="iconfont icon-jinakangbaoicons17"></text>
        <text class="a">所有商品精挑细选</text>
      </div>
      <div class="item flex ali_center">
        <text class="iconfont icon-jinakangbaoicons17"></text>
        <text class="a">售后无忧</text>
      </div>
    </div> -->
    <!-- <div class="title flex ali_center flex_between">
      <div class="left">
        购物数量：<text class="a">{{count}}</text>
      </div>
      <div class="right" @click="isEdit = !isEdit">
        <div class="edit" v-if="!isEdit">管理</div>
        <div class="cancel" v-else>取消</div>
      </div>
    </div> -->
    <div class="list valid">
      <div
        class="item flex ali_center"
        v-for="(item, index) in validList"
        :key="index"
      >
        <div class="left" @click="checkItem(item, index)">
          <!-- <text
            class="iconfont icon-dui1"
            v-if="item.checked || all_checked"
          ></text> -->
          <!-- <text class="iconfont icon-yuan" v-else></text> -->
        </div>
        <div class="right">
          <img
            lazy-load="true"
            v-if="yc_type == 0"
            class="pic"
            src="../../assets/logo.jpg"
          />
          <img lazy-load="true" v-else class="pic" :src="item.image" />
          <div class="infos">
            <div class="store_name">{{ item.store_name }}</div>
            <!-- <div class="suk">库存:{{ item.stock || "0" }}</div> -->
            <div class="price_num flex flex_between">
              <div class="price" v-if="yc_type == 1">
                ￥{{ item.price || 0 }}
              </div>
              <!-- <div class="num flex">
                <div
                  class="sub"
                  :class="{ on: item.cart_num == 0 }"
                  @click="sub(index, 1, item.id)"
                >
                  -
                </div>
                <input
                  class="cart_num"
                  type="text"
                  v-model="item.cart_num"
                  value=""
                  @blur="computedCart"
                />
                <div class="add" @click="sub(index, 2, item.id)">+</div>
              </div> -->
            </div>
          </div>
          <div class="exchange" @click="exchange(item.id)">换货</div>
        </div>
      </div>
    </div>
    <div v-if="validList.length == 0" class="tip">暂无能更换的商品~</div>
    <!-- <div class="footer flex ali_center flex_between">
      <div class="left flex ali_center" @click="checkAll">
        <div style="margin-right: 0.05rem;">数量</div>
        {{ cart_id }}
      </div>
      <div class="right">
        <div class="btn" @click="goSubmit">立即换货</div>
      </div>
    </div> -->
    <div class="mark2" v-if="show" @click="show = false"></div>
    <div class="box2" v-if="show">
      <div class="title2">
        请输入换货数
      </div>
      <input
        type="number"
        v-model="cart_id"
        placeholder="请输入换货数"
        class="inputs"
        placeholder-style="font-size: 28rpx;text-align: center;"
      />
      <div class="bnt" @click="goSubmit">
        确定
      </div>
    </div>
  </div>
</template>

<script>
// import { cartCount, cartList, cartDel, collect } from "../../api/shop.js";
import { ware_house, stockHh } from "../../api/order.js";
export default {
  name: "cart",
  data() {
    return {
      list: [],
      showMask: false,
      isEdit: false,
      count: 0,
      cart_num: 0,
      validList: [],
      invalidList: [],
      cart_id: "",
      all_checked: false,
      all_price: 0,
      id: "",
      levelname: "",
      num: "",
      loading: false,
      loadend: false,
      limit: 20,
      page: 1,
      pid: "",
      unique: "",
      h_id: "",
      show: false,
      yc_type: 0,
      img: ""
    };
  },
  mounted() {
    this.id = this.$route.query.price;
    this.unique = this.$route.query.unique;
    this.pid = this.$route.query.pid;
    this.num = this.$route.query.num;
    this.yc_type = this.$route.query.yc_type;
    this.img = this.$route.query.img;
    this.ware_house2();
    // document.addEventListener("visibilitychange", this.handleVisiable);
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.ware_house2();
    });
  },
  methods: {
    exchange(id) {
      this.h_id = id;
      this.show = true;
    },
    handleVisiable(e) {
      switch (e.target.visibilityState) {
        case "prerender":
          console.log("网页预渲染，内容不可见");
          break;
        case "hidden":
          console.log("内容不可见，处理后台、最小化、锁屏状态");
          break;
        case "visible":
          console.log("处于正常打开");
          this.ware_house2();
          break;
      }
    },
    closeAuth() {
      this.showMask = false;
    },
    onloadFun() {
      // this.getCount();
      this.getList();
    },
    ware_house2() {
      let that = this;
      if (that.loading || that.loadend) return;
      that.loading = true;
      let data = {
        page: that.page,
        limit: that.limit,
        price: that.id,
        yc_type: that.yc_type
      };
      ware_house(data)
        .then(res => {
          let list = res.data.map(item => {
            return {
              ...item,
              checked: false,
              cart_num: 0
            };
          });
          that.loading = false;
          that.page++;
          that.validList = that.page == 1 ? list : that.validList.concat(list);
          that.loadend = that.limit > res.data.length;
          // that.validList = list
        })
        .catch(res => {
          that.$dialog.error(res.msg);
          // that.$tips({
          //   title: res.msg
          // });
        });
    },
    goSubmit() {
      let that = this;

      if (that.cart_id / 1 > that.num / 1) {
        return that.$dialog.toast({ mes: "数量超过换取数" });
      }
      if (that.cart_id / 1 < 1) {
        return that.$dialog.toast({ mes: "请输入大于0的整数" });
      }
      let data = {
        hh_pid: this.h_id,
        pid: this.pid,
        unique: this.unique,
        num: this.cart_id,
        yc_type: that.yc_type
      };
      stockHh(data)
        .then(res => {
          that.show = false;
          that.cart_id = "";
          setTimeout(() => {
            that.$router.go(-1);
          }, 2000);
          that.$dialog.message(res.msg);
        })
        .catch(res => {
          that.cart_id = "";
          that.show = false;
          that.$dialog.error(res.msg);
        });
    },

    checkAll() {
      this.all_checked = !this.all_checked;
      let list = this.validList;
      list.map(ele => {
        ele.checked = this.all_checked;
      });
      this.validList = list;
      this.computedCart();
    },
    sub(index, type) {
      let list = this.validList;
      let item = list[index];
      if (type == 1) {
        if (item.cart_num == 0) return (this.cart_id = 0);
        item.cart_num--;
      } else {
        list.forEach(i => {
          if (item.id != i.id) {
            i.cart_num = 0;
          }
        });
        item.cart_num++;
      }
      this.h_id = item.id;
      this.cart_id = item.cart_num;
      this.validList[index] = item;
      // this.computedCart();
      // let data = {
      //   id: id,
      //   number: item.cart_num
      // }
      // cartNum(data).then((res) => {
      //   console.log(res)
      // }).catch((res) => {
      //   this.$tips({
      //     title: res.msg
      //   });
      // })
    },
    checkItem(item, index) {
      let list = this.validList;
      let arr = [];
      list.map((ele, ind) => {
        if (index == ind) {
          ele.checked = !item.checked;
        }
        if (ele.checked) {
          arr.push(true);
        }
      });
      this.all_checked = arr.length == list.length;
      this.validList = list;
      this.computedCart();
    },
    computedCart() {
      let price = 0,
        cart_num = 0,
        list = this.validList,
        cartarr = [];
      list.map(ele => {
        if (ele.checked) {
          if (ele.cart_num > 0) {
            cartarr.push({
              id: ele.id,
              num: ele.cart_num
            });
          }
          let elePrice = ele.price;
          price += Number(elePrice) * Number(ele.cart_num);
          cart_num += ele.cart_num / 1;
        }
      });
      this.cart_id = cartarr;
      this.all_price = price.toFixed(2);
      this.cart_num = cart_num;
    }
    // getList() {
    //   cartList()
    //     .then(res => {
    //       let list = res.data.valid;
    //       list.map(ele => {
    //         ele["checked"] = false;
    //       });
    //       this.validList = list;
    //       this.invalidList = res.data.invalid;
    //       // this.computedCart();
    //     })
    //     .catch(res => {
    //       console.log(res);
    //     });
    // },
    // getCount() {
    //   cartCount()
    //     .then(res => {
    //       this.count = res.data.count;
    //     })
    //     .catch(res => {
    //       console.log(res);
    //     });
    // }
  }
};
</script>

<style lang="scss" scoped>
.mark2 {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  font-size: 10;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 599;
}

.box2 {
  position: fixed;
  top: 4rem;
  left: 1.25rem;
  width: 5rem;
  border-radius: 0.16rem;
  overflow: hidden;
  background-color: #fff;
  font-size: 0.32rem;
  color: #333;
  z-index: 600;

  .title2 {
    font-size: 0.36rem;
    font-weight: bold;
    text-align: center;
    margin-top: 0.3rem;
  }

  .text {
    text-align: center;
    margin-top: 0.3rem;
  }

  .inputs {
    display: inline-block;
    text-align: center;
    margin-top: 0.3rem;
    height: 0.7rem;
    width: 4.52rem;
    margin-left: 0.24rem;
    border-radius: 0.1rem;
    border: 0.01rem solid #f7f7f7;
    background-color: #f7f7f7;
    padding: 0 0.24rem;
    color: #333;
  }

  .bnt {
    margin-top: 0.5rem;
    width: 100%;
    height: 0.8rem;
    text-align: center;
    line-height: 0.8rem;
    border-top: 0.01rem solid #ccc;
    // background-color: #97bded;
  }
}
.cart {
  .title8 {
    width: 100%;
    height: 0.8rem;
    text-align: center;
    line-height: 0.8rem;
    background-color: #ffe8a0;
  }

  .goHome {
    color: #fc4141;
    border-radius: 0.43rem;
    line-height: 0.6rem;
    border: 0.01rem solid #fc4141;
    width: 2rem;
    text-align: center;
    margin: 0 auto;
    font-size: 0.28rem;
  }

  .top {
    height: 0.76rem;
    color: #8c8c8c;
    font-size: 0.22rem;

    .iconfont {
      font-size: 0.25rem;
      margin-right: 0.1rem;
    }
  }

  .title {
    height: 0.8rem;
    padding: 0 0.3rem;
    font-size: 0.28rem;
    color: #282828;
    background-color: #fff;
    margin-bottom: 20rem;

    .left {
      display: flex;
      align-items: center;
      .a {
        color: #fc4141;
      }
    }

    .right {
      display: flex;
      .edit,
      .cancel {
        font-size: 0.26rem;
        color: #282828;
        width: 1rem;
        height: 0.46rem;
        line-height: 0.44rem;
        text-align: center;
        border-radius: 0.06rem;
        border: 0.01rem solid #868686;
      }
    }
  }

  .list {
    padding-bottom: 1rem;
    .item {
      background-color: #fff;
      padding: 0.25rem 0.3rem;
      margin-bottom: 0.15rem;

      .left {
        margin-right: 0.2rem;

        .icon-dui1 {
          color: #fc4141;
        }
      }

      .right {
        display: flex;
        .pic {
          width: 1.6rem;
          height: 1.6rem;
          border-radius: 0.06rem;
          margin-right: 0.2rem;
        }
        .exchange {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 1.2rem;
          height: 0.6rem;
          color: #fff;
          margin-top: 0.6rem;
          margin-left: 0.1rem;
          border-radius: 0.3rem;
          background-color: #0e98fd;
        }
        .infos {
          width: 3.7rem;

          .store_name {
            font-size: 0.28rem;
            color: #282828;
          }

          .suk {
            margin-top: 0.16rem;
            font-size: 0.24rem;
            color: #868686;
          }

          .price_num {
            display: flex;
            justify-content: space-between;
            margin-top: 0.26rem;

            .price {
              font-size: 0.32rem;
              color: #282828;
            }

            .num {
              display: flex;
              text-align: center;
              line-height: 0.44rem;

              .sub,
              .add {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 0.66rem;
                height: 0.44rem;
                color: #a4a4a4;
                border: 0.01rem solid #a4a4a4;

                &.on {
                  border-color: #e3e3e3;
                  color: #dedede;
                }
              }

              .sub {
                border-right: 0;
              }

              .add {
                border-left: 0;
              }

              .cart_num {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.24rem;
                border: 0.01rem solid #a4a4a4;
                width: 0.62rem;
                height: 0.44rem;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 0.96rem;
    padding: 0 0.3rem;
    background-color: #fafafa;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 10;

    .left {
      display: flex;
      align-items: center;
      font-size: 0.28rem;
      color: #282828;

      .iconfont {
        margin-right: 0.2rem;
      }

      .icon-dui1 {
        color: #fc4141;
      }
    }

    .right {
      width: 2.26rem;
      height: 0.96rem;
      display: flex;
      align-items: center;
      .price {
        color: #fc4141;
        font-size: 0.3rem;
      }

      .btn {
        color: #fff;
        background-color: #0e98fd;
        line-height: 0.7rem;
        height: 0.7rem;
        border-radius: 0.35rem;
        width: 2.26rem;
        text-align: center;
        margin-left: 0.22rem;
        font-size: 0.3rem;
      }

      .collect {
        width: 1.6rem;
        line-height: 0.6rem;
        text-align: center;
        border-radius: 0.3rem;
        color: #fc4141;
        border: 1rem solid #fc4141;
        font-size: 0.3rem;
      }

      .del {
        width: 1.6rem;
        line-height: 0.6rem;
        text-align: center;
        border-radius: 0.3rem;
        color: #999;
        border: 0.01rem solid #999;
        font-size: 0.3rem;
        margin-left: 0.17rem;
      }
    }
  }
}
.tip {
  text-align: center;
  // margin-top: 0.4rem;
}
</style>
